module.exports = __webpack_public_path__ + "img/pop-icon.faafbb52.png";